import { Injectable } from '@angular/core';
import { RemoteConfigService } from 'src/app/lib/remote-config/remote-config.service';
import { TermsOfServiceAggregate } from './terms-of-service-aggregate';
import { TermsOfServiceUrl } from './terms-of-service-url';
import { TermsOfServiceVersion } from './terms-of-service-version';

@Injectable({ providedIn: 'root' })
export class TermsOfServiceRepository {
  constructor(private readonly remoteConfig: RemoteConfigService) {}

  get(): TermsOfServiceAggregate {
    const version = new TermsOfServiceVersion(
      this.remoteConfig.getNumber('terms_of_service_version'),
    );
    const url = new TermsOfServiceUrl(this.remoteConfig.getString('term_url'));
    return new TermsOfServiceAggregate({ version, url });
  }
}
